import React from "react";
import { Modal } from "react-bootstrap";
import { locationDev } from "../../services/Servicos";
import "./UserImageModal.scss";

export default function UserImageModal({ 
	show, 
	onHide, 
	userImage, 
	userName = "Usuário",
	onImageError = null 
}) {
	const getImageUrl = (image) => {
		if (!image) return null;
		return image.startsWith('http') ? image : `${locationDev}/files/users/${image}`;
	};

	const handleImageError = (e) => {
		if (onImageError) {
			onImageError();
		} else {
			e.target.style.display = 'none';
			const fallbackDiv = e.target.nextSibling;
			if (fallbackDiv) {
				fallbackDiv.style.display = 'flex';
			}
		}
	};

	const getInitials = (fullName) => {
		if (!fullName) return "U";
		const nameParts = fullName.trim().split(" ");
		const firstInitial = nameParts[0]?.charAt(0)?.toUpperCase() || "";
		const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1]?.charAt(0)?.toUpperCase() || "" : "";
		return lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
	};

	return (
		<Modal 
			show={show} 
			onHide={onHide} 
			centered 
			size="lg"
			className="user-image-modal"
		>
			<Modal.Header closeButton className="border-0">
				<Modal.Title>{userName}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center p-4">
				<div className="user-image-container">
					{userImage ? (
						<>
							<img
								src={getImageUrl(userImage)}
								alt={`${userName} - Foto do perfil`}
								className="user-full-image"
								onError={handleImageError}
							/>
							<div className="image-fallback" style={{ display: 'none' }}>
								<div className="fallback-circle">
									<span className="fallback-initials">
										{getInitials(userName)}
									</span>
								</div>
								<p className="fallback-text mt-3">
									Imagem não disponível
								</p>
							</div>
						</>
					) : (
						<div className="image-fallback">
							<div className="fallback-circle">
								<span className="fallback-initials">
									{getInitials(userName)}
								</span>
							</div>
							<p className="fallback-text mt-3">
								Nenhuma imagem de perfil disponível
							</p>
						</div>
					)}
				</div>
			</Modal.Body>
			<Modal.Footer className="border-0 justify-content-center">
				<button 
					type="button" 
					className="btn btn-secondary"
					onClick={onHide}
				>
					Fechar
				</button>
			</Modal.Footer>
		</Modal>
	);
}
